module.exports = __webpack_public_path__ + "static/media/close.464ac6b8.svg";